import React, { useRef, useState } from "react";
import LinkButton from "../LinkButton";
import SocialNetworkLinks from "../SocialNetworkLinks";
import useOutsideClick from "../../hooks/useOutsideClick";
import Logo from "./../../images/svg/logo_square.inline.svg";
import ProfileIcon from "./../../images/svg/profile.inline.svg";
import * as styles from "./style.module.css";
import { sendEventToGa, trackQuizStart } from "../../helpers/ga";

type Props = {
  userLoggedIn: boolean;
};

const navList = [
  {
    title: "Products",
    link: "/product/protein",
    sublinks: [
      {
        title: "Protein",
        link: "/product/protein",
      },
      {
        title: "Hydration",
        link: "/product/hydration",
      },
      {
        title: "Pre-Workout",
        link: "/product/preworkout",
      },
      {
        title: "Performance Boosts",
        link: "/product/boosts",
      },
    ],
  },
  {
    title: "Ingredients",
    link: "/ingredients",
  },
  {
    title: "Science",
    link: "/science",
  },
  {
    title: "About us",
    link: "/mission",
  },
];

const Header = ({ userLoggedIn }: Props) => {
  const [openNav, setOpenNav] = useState(false);
  const [openProfile, setOpenProfile] = useState(false);
  const profileNavRef = useRef(null);

  const open = () => {
    setOpenNav(!openNav);
  };

  const openProfileNav = () => {
    setOpenProfile(!openProfile);
  };

  const closeProfileNav = () => {
    setOpenProfile(false);
  };

  useOutsideClick(profileNavRef, closeProfileNav);

  return (
    <header className={`${styles.header} ${openNav && styles.navopened}`}>
      <div className={styles.wrapper}>
        <a
          className={styles.logowrap}
          href="/"
          aria-label="Main page"
          title="Main page"
        >
          <Logo width={40} height={40} />
        </a>
        <nav className={styles.navbar}>
          <button
            className={`${styles.navbtn}`}
            onClick={open}
            type="button"
            aria-label="Menu"
          >
            <div className={`${styles.navicon} ${openNav && styles.active}`}>
              <span></span>
              <span></span>
            </div>
          </button>
          <ul className={styles.navlist}>
            {navList.map((item) => (
              <li key={item.title} className={item?.sublinks && styles.parent}>
                <a className={styles.navlink} href={item.link}>
                  {item.title}
                </a>
                {item?.sublinks && item?.sublinks.length > 0 && (
                  <ul className={styles.sublinks}>
                    {item.sublinks.map((subitem) => (
                      <li key={subitem.title}>
                        <a className={styles.sublink} href={subitem.link}>
                          {subitem.title}
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
            {!userLoggedIn && (
              <li className={styles.mobilenav}>
                <LinkButton
                  href="/quiz/"
                  text="Take The Quiz"
                  style={{
                    display: "block",
                    margin: "20px auto 0",
                    background: "#77B1AC",
                  }}
                />
              </li>
            )}
            <li className={styles.mobilenav}>
              <a className={styles.sublink} href="/blog">
                Our Blog
              </a>
            </li>
            {!userLoggedIn && (
              <li className={styles.mobilenav}>
                <a className={styles.sublink} href="/login">
                  Sign In
                </a>
              </li>
            )}
            <li className={styles.mobilenav}>
              <div className={styles.socialwrap}>
                <SocialNetworkLinks />
              </div>
            </li>
          </ul>
        </nav>

        <nav
          className={`${styles.profilenav} ${openProfile && styles.opened}`}
          ref={profileNavRef}
        >
          {userLoggedIn ? (
            <>
              <button
                className={styles.profilebtn}
                onClick={openProfileNav}
                type="button"
                aria-label="Profile menu"
              >
                <ProfileIcon />
              </button>
              <ul className={styles.profilelist}>
                <li>
                  <a className={styles.profilelink} href="/users/me">
                    My Profile
                  </a>
                </li>
                <li>
                  <a className={styles.profilelink} href="/logout/">
                    Logout
                  </a>
                </li>
              </ul>
            </>
          ) : (
            <>
              <a className={styles.signin} href="/login/">
                Sign In
              </a>
              <LinkButton
                onClick={trackQuizStart}
                className={styles.personalize}
                href="/quiz/"
                text="Personalize"
                style={{ padding: "13px 36px 14px" }}
              />
            </>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;
